package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.AddSourceRequestDto
import com.iptvplayer.shared.data.remote.dto.SourceDto
import com.iptvplayer.shared.domain.model.IptvSource
import com.iptvplayer.shared.util.Constants
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

class SourceApi(private val client: HttpClient) {

    suspend fun getSources(): List<SourceDto> =
        client.get("${Constants.BASE_URL}/api/sources").body()

    suspend fun addSource(request: AddSourceRequestDto): SourceDto =
        client.post("${Constants.BASE_URL}/api/sources") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun removeSource(id: String) {
        client.delete("${Constants.BASE_URL}/api/sources/$id")
    }
}

// ──────────────────── Mappers ────────────────────

fun SourceDto.toDomain(): IptvSource? = when (type) {
    "m3u" -> IptvSource.M3USource(id = id, name = name, url = url.orEmpty())
    "xtream" -> IptvSource.XtreamSource(
        id = id,
        name = name,
        serverUrl = serverUrl.orEmpty(),
        username = username.orEmpty(),
        password = password.orEmpty()
    )
    else -> null
}

fun IptvSource.toAddRequest(): AddSourceRequestDto = when (this) {
    is IptvSource.M3USource -> AddSourceRequestDto(
        id = id, type = "m3u", name = name, url = url
    )
    is IptvSource.XtreamSource -> AddSourceRequestDto(
        id = id, type = "xtream", name = name,
        serverUrl = serverUrl, username = username, password = password
    )
}
